'use client';
import { scaleBand } from 'd3-scale';
import { useMemo } from 'react';
import { useSvgContext } from '../../context';
import { BAND } from './constants';

export default function useScaleBandX(data: unknown[], paddingInner: number, paddingOuter: number) {
  const { right, left, width } = useSvgContext();
  return useMemo(() => {
    const scale: any = scaleBand()
      .domain(data.map((_d: unknown, i: number) => i.toString()))
      .range([left, width - right])
      .paddingInner(paddingInner)
      .paddingOuter(paddingOuter);
    scale.type = BAND;
    return scale;
  }, [data, right, left, width, paddingInner, paddingOuter]);
}
